<template>
  <v-dialog
    v-model="isOpen"
    max-width="350"
    @click:outside.prevent="closeTaskCategoriesModal"
  >
    <v-card class="pa-5">
      <v-btn icon color="black" absolute top right @click="closeTaskCategoriesModal">
        <v-icon>$close</v-icon>
      </v-btn>
      <h3 class="text-center mb-10">Task Categories</h3>
      <div class="mb-5">
        <v-card
          v-for="category in taskCategories"
          :key="category.id"
          class="pa-0 d-flex justify-space-between align-center elevation-0 mb-3"
        >
          <v-col cols="10" class="pa-0">
            <v-text-field
              v-model="category.value"
              single-line
              solo
              v-on:change="taskChangeHandler(category)"
              height="20"
              :loading="category.isUpdating">
            </v-text-field>
          </v-col>
          <div>
            <v-btn fab small primary="transparent" class="elevation-0" :loading="delBtnLoading && cardClicked === category.id"  @click="deleteTaskCategory(category)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>
      <v-form ref="taskCategoryForm" lazy-validation>
        <v-flex xs12 class="d-flex align-center">
          <v-text-field
            v-model="title"
            placeholder="Category title"
            :rules="titleRules"
            value="true"
            required="false"
            autocomplete="off"
          ></v-text-field>
          <v-btn color="primary" @click="addCategoryHandler" :loading="btnLoading" class="ml-5">Add</v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import validationRules from '@/common/validationRules'
  export default {
    name: 'TaskCategoriesManage',
    props: ['isOpen', 'closeTaskCategoriesModal'],
    data: () => ({
      title: '',
      titleRules: validationRules.title,
      btnLoading: false,
      delBtnLoading: false,
      cardClicked: null
    }),
    computed: {
      ...mapGetters({
        taskCategories: 'getTaskCategories'
      })
    },
    methods: {
      async addCategoryHandler () {
        if (this.$refs.taskCategoryForm.validate()) {
          this.btnLoading = true
          const result = await this.$store.dispatch('addTaskCategory', this.title)
          if (result) {
            this.btnLoading = false
            this.title = ''
          }
          this.btnLoading = false
        }
      },
      async taskChangeHandler (category) {
        await this.$store.dispatch('updateTaskCategory', category)
      },
      async deleteTaskCategory (category) {
        this.cardClicked = category.id
        if (await this.$root.$confirmDialog.open(category.value)) {
          this.delBtnLoading = true
          await this.$store.dispatch('deleteTaskCategory', category.id)
          this.delBtnLoading = false
        }
        this.cardClicked = null
      }
    }
  }
</script>
